import React, { Component } from 'react'
import { withStyles } 		from 'material-ui/styles'
import {
	Route,
	Redirect,
	Switch } 				from 'react-router-dom';
import SettingsNav 			from '../navigation/SettingsNav'
import Currency 			from '../content/Currency'
import Countries 			from '../content/Countries'
import SchoolTypes 			from '../content/SchoolTypes'

const styles = {}

class SettingsContainer extends Component {
	constructor(props) {
		super(props)

		this.state = {}
	}

	render() {
		return(
			<div>
				<SettingsNav />
				<Switch>
					<Route
						path="/admin/settings/currency"
						exact
						component={Currency} />
					<Route
						path="/admin/settings/countries"
						exact
						component={Countries} />
					<Route
						path="/admin/settings/school-types"
						exact
						component={SchoolTypes} />
				</Switch>
			</div>
		)
	}
}

export default withStyles(styles)(SettingsContainer);



// WEBPACK FOOTER //
// ./src/components/containers/SettingsContainer.js